import React from 'react';
import './notfound.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

class NotFound extends React.Component {
    render() {
        return(
            <div className="errorPage">
                <p className="error-msg">
                    Oops! Something is wrong.
                </p>
                <Link to="/">
                    <span className="home-button">
                        <FontAwesomeIcon className="home-icon icon" icon={['fas', 'home']} size="lg" /> 
                        Go back in home page
                    </span>
                </Link>
            </div>
        );
    }
}

export default NotFound;